<template>
  <WdsStack v-if="hires.length > 0" direction-column gap-md>
    <WdsText :text="title" secondary />
    <BaseShowMore
      fade
      collapsable
      :collapse-text="$t('See less jobs')"
      :collapsed-height="30"
      :delay="500"
      :expand-text="$t('See all jobs')"
      align-with-text
    >
      <WdsStack direction-column gap-md class="-tw-ml-1">
        <div
          v-for="hire in hires"
          :key="hire.id"
          class="tw-p-3 tw-rounded-md tw-border-solid tw-border tw-border-gray-200"
        >
          <WdsStack direction-column gap-sm>
            <a
              :href="laravelNamedRoute(namedRoutes.jobs.show, { job: hire.job.id })"
              class="hover:tw-bg-true-gray-50"
            >
              <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
                <WdsText
                  :text="hire.job.name"
                  :sub-text="`${hire.company.name} on ${hire.createdAt}`"
                />

                <WdsIcon size="18" name="chevron-right" class="tw-text-gray-600" />
              </div>
            </a>
            <div v-if="hire.paymentRequests.data.length > 0">
              <WdsStack wrap justify-left gap-sm>
                <span
                  v-for="paymentRequest in hire.paymentRequests.data"
                  :key="paymentRequest.number"
                >
                  <WdsLabel primary subtle sm>
                    <a
                      :href="laravelNamedRoute(namedRoutes.bills.pdf, { bill: paymentRequest.id })"
                      target="_blank"
                      :title="$t('Download payment request pdf')"
                    >
                      {{ $t('Bill') }} #{{ paymentRequest.number }}
                      <WdsIcon :name="WdsIconNameEnum.RECEIPT" size="16" />
                    </a>
                  </WdsLabel>
                </span>
              </WdsStack>
            </div>
          </WdsStack>
        </div>
      </WdsStack>
    </BaseShowMore>
  </WdsStack>
</template>

<script setup>
import { defineProps } from 'vue'
import { WdsStack, WdsLabel, WdsIcon, WdsText, WdsIconNameEnum } from '@worksome/wds-components'

import BaseShowMore from '@/components/BaseShowMore.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

defineProps({
  hires: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: $t('Jobs'),
  },
})
</script>
